import { render, staticRenderFns } from "./TrademarkList.vue?vue&type=template&id=56da1bd8&"
import script from "./TrademarkList.vue?vue&type=script&lang=js&"
export * from "./TrademarkList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkList.vue?vue&type=style&index=0&id=56da1bd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports